var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group-material",
      attrs: { id: _vm.id + "-container" },
      on: { click: _vm.handleSelect2Click },
    },
    [
      _c("select2", {
        ref: "referrersSelect",
        attrs: {
          id: _vm.id,
          value: _vm.referrerId,
          name: "referrer",
          options: _vm.options(),
          "format-data": _vm.formatData,
          multiple: _vm.multiple,
        },
        on: { change: _vm.updateReferrer },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "bar" }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "title text-light-gray mb-2 mb-lg-0",
          attrs: { for: "" + _vm.id },
        },
        [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc(_vm.labelKey, 1))))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }